import StartTrialFooter from './StartTrialFooter'

export default StartTrialFooter
